import { axiosObject } from "../strapiServiceConfig";

function getAllBlogs() {
  return new Promise((resolve, reject) => {
    let uri = `api/articles?populate=category.categoryIcon,author,image`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getAllBlogsWithPagination(page: number) {
  return new Promise((resolve, reject) => {
    let uri = `api/articles?pagination[page]=${page}&pagination[pageSize]=7&populate=category.categoryIcon,author,image&sort[publishedAt]=desc`;

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getSingleBlog(slug: any) {
  return new Promise((resolve, reject) => {
    let uri = `/api/articles?filters[slug]=${slug}&populate=category.categoryIcon,author,image`;

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getAllArticleByCategory(slug: any, page: any) {
  return new Promise((resolve, reject) => {
    let uri = `api/articles?pagination[page]=${page}&pagination[pageSize]=7&populate=category.categoryIcon,author,image&filters[category][slug]=${slug}&sort[publishedAt]=desc`;

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getAllArticlesBySearch(searchValue: any) {
  return new Promise((resolve, reject) => {
    let uri = `api/articles?filters[title][$containsi]=${searchValue}&populate=category.categoryIcon,author,image`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getAllCategories() {
  return new Promise((resolve, reject) => {
    let uri = `api/categories?populate=*`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getOnlyCategories() {
  return new Promise((resolve, reject) => {
    let uri = `api/categories`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors.response.data);
      });
  });
}

function getAllBannersWithType(type: string) {
  return new Promise((resolve, reject) => {
    let uri = `api/banners?filters[type]=${type}&sort[publishedAt]=desc&populate=*`;
    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors?.response?.data);
      });
  });
}

export {
  getAllBlogs,
  getAllBlogsWithPagination,
  getSingleBlog,
  getAllArticleByCategory,
  getAllArticlesBySearch,
  getAllCategories,
  getOnlyCategories,
  getAllBannersWithType,
};
